module.exports = __webpack_public_path__ + "img/Sweden.8dba3212.png";